import { useEffect, useState } from "react";
import CircularProgress from "@mui/material/CircularProgress";
import SoftBox from "components/SoftBox";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Card from "@mui/material/Card";
import service from "../../../admin/api/services";
import { useNavigate } from "react-router-dom";

const Index = () => {
    const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  const checkAuthorization = async () => {
    try {
      const res = await service.auth.checkAuthorization();
      // Optional: handle success response if needed
    } catch (error) {
      if (error?.response?.status === 401) {
        localStorage.clear()
        navigate('/login');
      } else {
        console.error("Authorization check failed:", error);
      }
    }
  };

  useEffect(() => {
    checkAuthorization();
  }, []);
    return (
        <DashboardLayout>
            <DashboardNavbar />
            <SoftBox mt={3}>
                <Card
                    className="glassmorphism-card"
                    sx={{
                        width: "100%",
                        height: "84vh",
                        position: "relative",
                        overflow: "hidden",
                        boxShadow: 2,
                    }}
                >
                    {/* Loader Overlay */}
                    {loading && (
                        <SoftBox
                            sx={{
                                position: "absolute",
                                top: 0,
                                left: 0,
                                width: "100%",
                                height: "100%",
                                backgroundColor: "rgba(255, 255, 255, 0.7)",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                zIndex: 10,
                            }}
                        >
                            <CircularProgress color="black" />
                        </SoftBox>
                    )}

                    {/* Iframe */}
                    <iframe
                        src="https://merchant.1onus.com:5601/login?next=%2Fapp%2Fdiscover#/?_g=(filters:!(),refreshInterval:(pause:!t,value:0),time:(from:now-15m,to:now))&_a=(columns:!(),filters:!(),index:'complaints*',interval:auto,query:(language:kuery,query:''),sort:!())"
                        width="100%"
                        height="100%"
                        style={{ border: "none" }}
                        title="Kibana Dashboard"
                        onLoad={() => setLoading(false)}
                    />
                </Card>
            </SoftBox>
        </DashboardLayout>
    );
};

export default Index;
